module.exports = __webpack_public_path__ + "static/img/materialsInfo5.10382e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo5.png
// module id = SkJe
// module chunks = 2